import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions.js';
import mutations from './mutations.js';
import getters from './getters.js';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    geojson: {},
    mainFilters: [],
    activeFilters: [],
    mainFiltersLoaded: false,
    secondaryFilters: [],
    secondaryFiltersLoaded: false,
    geojsonLoaded: false,
    noResults: false,
    formValues: {},
    results: [],
    endpoints: {},
  },
  actions,
  mutations,
  getters,
});

export default store;
